import { FC, useEffect, useMemo, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import { brandsApi } from "../../../../services/sideMenus";
import "./privacy.scss";
import HtmlRender from "../../../../components/UI/HtmlRender";
import HelmetTitle from "../../../../components/Helmet";
import { TEMRS_TYPES } from "../../../../constants/url";

interface IPrivacyPolicyProps {
  type: string;
}

const PrivacyPolicy: FC<IPrivacyPolicyProps> = ({ type }) => {
  const { countryId } = useSelector((state: RootState) => ({
    countryId: state.applicationReducer.countryId,
  }));

  const [policy, setPolicy] = useState("");
  const modelref = useRef<any>();

  const title = useMemo(() => {
    switch (type) {
      case "Privacy Policy":
        return "Privacy Policy";
      case "Privacy Policy US State":
        return "Your US State Privacy Rights";
      case "Privacy Policy Children":
        return "Children's Online Privacy Policy";
      case "Investors":
        return "Investors";
      case "Terms of Use":
        return "Terms of Use";
      case "Terms":
        return "Terms of Use";
      case "Interest-Based Ads":
        return "Interest-Based Ads";
      case "Personal Information":
        return "Do Not Sell or Share My Personal Information";
      case TEMRS_TYPES.ETIX_TERMS:
        return TEMRS_TYPES.ETIX_TERMS;
      case "Rewards Terms & Condition - Angelika":
        return "Rewards Terms & Condition - Angelika";
      case "Site Disclaimer":
        return "Site Disclaimer";
      case TEMRS_TYPES.GIFT_CARD_TERMS:
        return "";
      case "Group Booking Terms":
        return "Group Sales Terms";
      case "Promo Terms & Condition":
        return "Promo Terms & Condition";  
      case "Employment Privacy Policy":
        return "Employment Privacy Policy"  
      case "Privacy Notice":
        return "Privacy Policy";
      case "Cinema Rewards Terms":
        return "Cinema Rewards Terms"   
      default:
        return "Privacy Policy";
    }
  }, [type]);

  useEffect(() => {
    if (countryId) {
      const getPolicy = async () => {
        const { data } = await brandsApi({ countryId: countryId });
        if (data && data.length > 0) {
          const datas = data[0];
          if (datas && datas.data) {
            const { content } = datas.data.find((v: any) =>
              (v.title == type || v.title == title)
            );
            setPolicy(content ? content : "");
            if(modelref && modelref?.current){
              modelref?.current?.focus();
            }
          }
        }
      };
      getPolicy();
    }
  }, [countryId]);

  return (
    <div className="privacy-policy-popup">
      <HelmetTitle title={title} description={title}/>
      <div className="modal-header">
        <div className="title title_append">{title}</div>
      </div>
      <div className="modal-body" ref={modelref} tabIndex={-1}>
        <HtmlRender content={policy} />
      </div>
    </div>
  );
};

export default PrivacyPolicy;
